import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  TextField,
  Button,
  Paper,
} from "@mui/material";
import {
  LocationOn,
  Phone,
  Email,
  AccessTime,
  Send,
  WhatsApp,
} from "@mui/icons-material";
import { PublicLayout } from "../../components/Layout/PublicLayout";

const breadcrumbsData = [
  { label: "Inicio", path: "/" },
  { label: "Contacto", path: "/contacto" },
];

const contactInfo = [
  {
    icon: <LocationOn sx={{ fontSize: 28 }} />,
    title: "Visítanos",
    lines: [
      "Calle José María Morelos, #673",
      "Zona Centro, Guadalajara, Jalisco",
      "C.P 44100",
    ],
  },
  {
    icon: <Phone sx={{ fontSize: 28 }} />,
    title: "Llámanos",
    lines: ["+52 56-1839-1680"],
  },
  {
    icon: <Email sx={{ fontSize: 28 }} />,
    title: "Escríbenos",
    lines: ["merrycolorventas@gmail.com"],
  },
  {
    icon: <AccessTime sx={{ fontSize: 28 }} />,
    title: "Horarios",
    lines: ["Lun - Vie: 8:00 AM - 7:00 PM", "Sábado: 9:00 AM - 6:00 PM"],
  },
];

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    message: "",
  });

  const whatsappNumber = "5573626635";

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappMessage = `Hola, soy ${formData.fullname}. Mi correo es ${formData.email}. ${formData.message}`;
    const encodedMessage = encodeURIComponent(whatsappMessage);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, "_blank");
    setFormData({ fullname: "", email: "", message: "" });
  };

  return (
    <PublicLayout breadcrumb={breadcrumbsData} breadcrumbTitle="Contacto">
      {/* Hero Section */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #801F56 0%, #9A457F 50%, #FAA5B7 100%)",
          py: { xs: 8, md: 12 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative Elements */}
        <Box
          sx={{
            position: "absolute",
            top: -50,
            right: -50,
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: -30,
            left: "20%",
            width: 100,
            height: 100,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
          }}
        />

        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            sx={{
              fontSize: { xs: "2.2rem", md: "3rem" },
              fontWeight: 800,
              color: "#fff",
              textAlign: "center",
              mb: 2,
            }}
          >
            💌 Contáctanos
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.2rem" },
              color: "#fff",
              opacity: 0.9,
              textAlign: "center",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Estamos aquí para ayudarte. Nuestro equipo está listo para responder
            todas tus preguntas y brindarte la mejor atención.
          </Typography>
        </Container>
      </Box>

      {/* Contact Cards */}
      <Container maxWidth="lg" sx={{ mt: -6, position: "relative", zIndex: 2 }}>
        <Grid container spacing={3}>
          {contactInfo.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "16px",
                  textAlign: "center",
                  background: "#fff",
                  border: "1px solid #f0f0f0",
                  height: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 15px 40px rgba(128, 31, 86, 0.12)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "16px",
                    background: "linear-gradient(135deg, #FAA5B7 0%, #F0C9D5 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                    color: "#801F56",
                  }}
                >
                  {item.icon}
                </Box>
                <Typography
                  sx={{ fontWeight: 700, color: "#333", mb: 1, fontSize: "1.1rem" }}
                >
                  {item.title}
                </Typography>
                {item.lines.map((line, i) => (
                  <Typography key={i} sx={{ color: "#666", fontSize: "0.9rem" }}>
                    {line}
                  </Typography>
                ))}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Form Section */}
      <Box sx={{ py: 8, background: "#FFF5F8" }}>
        <Container maxWidth="md">
          <Grid container spacing={6} alignItems="center">
            {/* Text Content */}
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  fontSize: { xs: "1.8rem", md: "2.2rem" },
                  fontWeight: 800,
                  color: "#333",
                  mb: 2,
                }}
              >
                En MerryColor, nos importa tu satisfacción 💅
              </Typography>
              <Typography sx={{ color: "#666", lineHeight: 1.8, mb: 3 }}>
                Si tienes alguna pregunta o necesitas ayuda, envíanos un mensaje
                y nuestro equipo se pondrá en contacto contigo para ofrecerte la
                mejor solución.
              </Typography>
              <Typography sx={{ color: "#666", lineHeight: 1.8 }}>
                Nuestros expertos están siempre disponibles para asesorarte y
                ayudarte a elegir el producto perfecto al mejor precio.
              </Typography>

              {/* WhatsApp Direct */}
              <Box
                component="a"
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1.5,
                  mt: 4,
                  py: 1.5,
                  px: 4,
                  borderRadius: "50px",
                  background: "#25D366",
                  color: "#fff",
                  textDecoration: "none",
                  fontWeight: 700,
                  transition: "all 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 5px 25px rgba(37, 211, 102, 0.3)",
                  },
                }}
              >
                <WhatsApp />
                Chat directo por WhatsApp
              </Box>
            </Grid>

            {/* Form */}
            <Grid item xs={12} md={7}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  borderRadius: "24px",
                  background: "#fff",
                  boxShadow: "0 10px 50px rgba(128, 31, 86, 0.08)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 700,
                    color: "#333",
                    mb: 1,
                    textAlign: "center",
                  }}
                >
                  ✉️ Escríbenos
                </Typography>
                <Typography
                  sx={{ color: "#666", textAlign: "center", mb: 3 }}
                >
                  Te responderemos lo antes posible
                </Typography>

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Nombre completo"
                        value={formData.fullname}
                        onChange={(e) =>
                          setFormData({ ...formData, fullname: e.target.value })
                        }
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            "&:hover fieldset": { borderColor: "#801F56" },
                            "&.Mui-focused fieldset": { borderColor: "#801F56" },
                          },
                          "& .MuiInputLabel-root.Mui-focused": { color: "#801F56" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Correo electrónico"
                        type="email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            "&:hover fieldset": { borderColor: "#801F56" },
                            "&.Mui-focused fieldset": { borderColor: "#801F56" },
                          },
                          "& .MuiInputLabel-root.Mui-focused": { color: "#801F56" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Mensaje"
                        multiline
                        rows={4}
                        value={formData.message}
                        onChange={(e) =>
                          setFormData({ ...formData, message: e.target.value })
                        }
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            "&:hover fieldset": { borderColor: "#801F56" },
                            "&.Mui-focused fieldset": { borderColor: "#801F56" },
                          },
                          "& .MuiInputLabel-root.Mui-focused": { color: "#801F56" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        endIcon={<Send />}
                        sx={{
                          py: 1.5,
                          borderRadius: "12px",
                          background: "linear-gradient(135deg, #801F56 0%, #9A457F 100%)",
                          fontWeight: 700,
                          fontSize: "1rem",
                          textTransform: "none",
                          "&:hover": {
                            background: "linear-gradient(135deg, #6B1847 0%, #801F56 100%)",
                          },
                        }}
                      >
                        Enviar mensaje
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Map Section */}
      <Box sx={{ height: "400px", position: "relative" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.9424!2d-103.34!3d20.67!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDQwJzEyLjAiTiAxMDPCsDIwJzI0LjAiVw!5e0!3m2!1sen!2smx!4v1"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="MerryColor Location"
        />
      </Box>
    </PublicLayout>
  );
};

export default ContactPage;
